export const processStatuses = {
	pending: 'PENDING',
	success: 'SUCCESS',
	failed: 'FAILED',
	error: 'ERROR',
}
